export const normalizeMsisdn = (msisdn) => {
  if (!msisdn) return msisdn;
  const digits = msisdn.replace(/\D/g, '');
  if (digits.startsWith('0')) {
    return `92${digits.slice(1)}`;
  }
  return digits;
};

// Key holding the encrypted `a` value. jt/gen expects this value (never the
// plain number), so it has to survive across reloads for the 401 refresh flow.
export const ACCESS_CODE_KEY = 'accessCode';

// Older links carried the plain number in `a`; new ones carry an encrypted blob.
export const isPlainMsisdn = (value) =>
  typeof value === 'string' && /^\+?\d[\d\s()-]*$/.test(value.trim());

/**
 * Picks the plain MSISDN out of a jt/gen response body, falling back to the
 * value we sent when it was a plain number (legacy links).
 * @param {Object} responseData - The jt/gen response body
 * @param {string} sentValue - The value posted as `msisdn`
 * @returns {string|null} - The normalized plain MSISDN, or null
 */
export const resolveMsisdnFromAuthResponse = (responseData, sentValue) => {
  const fromBody = responseData?.data?.msisdn ?? responseData?.msisdn;
  if (fromBody) return normalizeMsisdn(String(fromBody));
  return isPlainMsisdn(sentValue) ? normalizeMsisdn(sentValue) : null;
};
